
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { BsGraphUp, BsFillFileTextFill, BsChatSquareDotsFill, BsFillQuestionCircleFill,BsFileBarGraphFill } from 'react-icons/bs';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import React from 'react';

const FeatureCard = styled.div`
  background: #fff;
  border: 2px solid ${({selected}) => selected ? '#007bff' : '#ccc'};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
  padding: 20px;
  margin: 10px;
  width: 250px;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &:hover {
    background-color: #f0f0f0;
    border-color: #007bff;
  }
`;
// Function component
const icons = {
  roadmap: <BsGraphUp size="2em" />,
  survey: <BsFillFileTextFill size="2em" />,
  feedback: <BsChatSquareDotsFill size="2em" />,
  customSurvey: <BsFillQuestionCircleFill size="2em" />,
  reports: <BsFileBarGraphFill size="2em" />
};

const FeatureSquare = ({ feature }) => {
  let history = useHistory();

  return (
    <FeatureCard onClick={() => history.push(feature.path)}>
      {icons[feature.type]}
      <h3>{feature.title}</h3>
      <p>{feature.description}</p>
    </FeatureCard>
  );
};

export default FeatureSquare;